import React from 'react';
import { motion } from 'framer-motion';
export function JourneyPath() {
  return <div className="fixed left-8 top-1/2 -translate-y-1/2 z-30 hidden xl:block pointer-events-none" data-id="element-106">
      <div className="relative h-[600px]" data-id="element-107">
        {/* Vertical path line */}
        <motion.div initial={{
        height: 0
      }} animate={{
        height: '100%'
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="absolute left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-teal-200 to-transparent" data-id="element-108" />

        {/* Journey markers */}
        {[{
        label: 'Start',
        top: '0%'
      }, {
        label: 'The Problem',
        top: '20%'
      }, {
        label: 'The Solution',
        top: '35%'
      }, {
        label: 'The Masters',
        top: '50%'
      }, {
        label: 'The Offer',
        top: '65%'
      }, {
        label: 'Transformation',
        top: '85%'
      }].map((marker, index) => <motion.div key={marker.label} initial={{
        opacity: 0,
        scale: 0
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: index * 0.3,
        duration: 0.5
      }} className="absolute left-1/2 -translate-x-1/2" style={{
        top: marker.top
      }} data-id="element-109">
            <div className="relative group pointer-events-auto cursor-help" data-id="element-110">
              <div className="w-2.5 h-2.5 rounded-full bg-white border-2 border-teal-500 shadow-sm transition-all duration-300 group-hover:scale-125 group-hover:bg-teal-500" data-id="element-111" />
              <div className="absolute left-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap" data-id="element-112">
                <span className="text-xs text-teal-600 font-bold tracking-widest uppercase bg-white px-2 py-1 rounded-md shadow-sm border border-teal-100" data-id="element-113">
                  {marker.label}
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>
    </div>;
}